import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=862e3d2c&scoped=true&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js&"
import style1 from "./WelcomeLayout.vue?vue&type=style&index=1&id=862e3d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862e3d2c",
  null
  
)

export default component.exports